import React, { PureComponent } from 'react';
import Section from '../../components/section/section';
import { Alert, Pagination } from 'antd';
import { connect } from 'react-redux';
import { getError, isBusy, withActions } from 'actionware';
import { getTranslate } from 'react-localize-redux';
import './history.less';
import Blotter from '../../components/blotter/blotter';
import * as numeral from 'numeral';
import {
  changePage,
  fetchLenderAccounts,
  fetchTransactionHistory,
  updateFilters
} from './historyActions';
import transactionHistoryIcon from '../../assets/transaction_history.svg';
import { dateFormat } from '../../common/constants';
import moment from 'moment';

@connect(
  ({
    localize,
    history: {
      accounts,
      historyRows,
      currentPage,
      currentLimit,
      currentFilters,
      total
    }
  }) => ({
    translate: getTranslate(localize),
    loading: isBusy(fetchLenderAccounts),
    error: getError(fetchLenderAccounts),
    loadingHistory:
      isBusy(fetchLenderAccounts) || isBusy(fetchTransactionHistory),
    errorHistory: getError(fetchTransactionHistory),
    accounts,
    historyRows,
    currentPage,
    currentLimit,
    currentFilters,
    total
  })
)
@withActions({
  fetchLenderAccounts,
  fetchTransactionHistory,
  updateFilters,
  changePage
})
class History extends PureComponent {
  componentDidMount() {
    this.props.fetchLenderAccounts();
  }

  changePage = page => {
    this.props.changePage(page);
  };

  get columns() {
    const { translate } = this.props;
    return [
      {
        title: translate('history.account'),
        dataIndex: 'accountName',
        key: 'accountName'
      },
      {
        title: translate('history.date'),
        dataIndex: 'date',
        key: 'date',
        render: record => moment(record.date).format(dateFormat)
      },
      {
        title: translate('history.transactionDescription'),
        dataIndex: 'transactionDescription',
        key: 'transactionDescription',
        colSpan: 2
      },
      {
        title: translate('history.cashFlow'),
        key: 'cashflow',
        render: record => (
          <span
            className={
              record.cashflowDirection === 'cash_in'
                ? 'direction-in'
                : 'direction-out'
            }
          >
            {record.cashflowDirection === 'cash_in' ? '+' : '-'}
            {` Rp ${numeral(record.cashflowAmount).format('0,0')}`}
          </span>
        )
      }
    ];
  }

  renderBlotter() {
    const { loadingHistory, errorHistory, historyRows, translate } = this.props;
    if (errorHistory) {
      return (
        <Alert
          message={translate('generic.loadingErrorCaption')}
          description={translate('generic.loadingErrorMessage')}
          type="error"
          showIcon
        />
      );
    }

    return (
      <Blotter
        columns={this.columns}
        loading={loadingHistory}
        dataSource={historyRows}
        emptyStateText={translate('history.emptyState')}
      />
    );
  }

  updateFilters(type) {
    return e => {
      this.props.updateFilters(type, e.target.value);
    };
  }

  get minDateFilters() {
    const { translate } = this.props;
    return [
      {
        text: translate('history.allTime')
      },
      {
        value: 'this_week',
        text: translate('history.thisWeek')
      },
      {
        value: 'this_month',
        text: translate('history.thisMonth')
      },
      {
        value: 'past_three_months',
        text: translate('history.pastThreeMonths')
      }
    ];
  }

  render() {
    const {
      translate,
      loading,
      error,
      accounts,
      historyRows,
      currentPage,
      currentLimit,
      total,
      currentFilters
    } = this.props;

    if (loading) {
      return <div />;
    }

    if (error) {
      return (
        <Alert
          message={translate('generic.loadingErrorCaption')}
          description={translate('generic.loadingErrorMessage')}
          type="error"
          showIcon
        />
      );
    }

    return (
      <Section
        className={'transaction-history'}
        title={translate('history.title')}
        icon={transactionHistoryIcon}
      >
        <div className={'actions'}>
          <div className={'filters'}>
            <span className={'label'}>{translate('history.filterBy')}</span>
            <select
              onChange={this.updateFilters('accountId')}
              className={'account'}
            >
              {[{ id: '', key: 0, name: translate('history.allAccount') }]
                .concat(accounts)
                .map(({ id, name }, key) => (
                  <option key={key} value={id}>
                    {name}
                  </option>
                ))}
            </select>
            <select
              value={currentFilters.minDate}
              onChange={this.updateFilters('minDate')}
              className={'date'}
            >
              {this.minDateFilters.map((filter, key) => (
                <option key={key} value={filter.value}>
                  {filter.text}
                </option>
              ))}
            </select>
            <select
              onChange={this.updateFilters('cashflowDirection')}
              className={'cash-flow'}
            >
              <option value="">{translate('history.allCashFlow')}</option>
              <option value="cash_in">{translate('history.moneyIn')}</option>
              <option value="cash_out">{translate('history.moneyOut')}</option>
            </select>
          </div>
          <div className={'pagination no-mobile'}>
            {historyRows.length ? (
              <Pagination
                onChange={this.changePage}
                current={currentPage}
                pageSize={currentLimit}
                total={total}
              />
            ) : null}
          </div>
        </div>
        <div className={'history-grid'}>{this.renderBlotter()}</div>
        <div className={'pagination mobile'}>
          {historyRows.length ? (
            <Pagination
              onChange={this.changePage}
              current={currentPage}
              pageSize={currentLimit}
              total={total}
            />
          ) : null}
        </div>
      </Section>
    );
  }
}

export default History;
